import React, { useEffect, useState } from "react";
import { Image, Modal, message } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import state from "../../../config/valtio/store";
import API from "../../../services/api-request";
import DynamicTable from "../../../components/DynamicTable";
import AddUsers from "./AddUsers";
import EditUsers from "./EditUsers";
import FilterMenu from "./FilterMenu";
import { appName, baseUrl } from "../../../config/url-config";
import axios from "axios";
import { getDataLogin } from "../../../utils/getDataLogin";

const { confirm } = Modal;

function Users() {
  // Fetch User
  const getUsers = async () => {
    state.LOADING = true;

    await API.Get("user")
      .then((result) => {
        setDataUsers(result.data);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Users Data!");
      });

    state.LOADING = false;
  };

  // Table Variable
  const [dataUsers, setDataUsers] = useState();
  const [selectedData, setSelectedData] = useState({});
  const [selectedDatas, setSelectedDatas] = useState([]);
  const columns = [
    {
      title: "No.",
      key: "id",
      width: 70,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Photo",
      dataIndex: "image",
      key: "image",
      width: 100,
      render: (_, { image }) => (
        <Image
          width={40}
          height={40}
          src={baseUrl + "/" + image}
          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi  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"
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name - b.name,
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "name",
      sorter: (a, b) => a.username - b.username,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email - b.email,
    },
    {
      title: "Client",
      dataIndex: "client",
      key: "client",
      sorter: (a, b) => a.client?.name - b.client?.name,
      render: (text) => text?.name || "-",
    },

    {
      title: "General Role",
      key: "general_role",
      render: (data) => {
        if (
          data.privilege.generale_role === null ||
          data.privilege.generale_role === ""
        ) {
          return "-";
        } else {
          return data.privilege.generale_role;
        }
      },
    },
    {
      title: "Privilege",
      key: "privilege",
      render: (data) => {
        if (data.privilege.name === null || data.privilege.name === "") {
          return "-";
        } else {
          return data.privilege.name;
        }
      },
    },
  ];
  const options = [
    {
      label: "Edit",
      key: "1",
      icon: <EditOutlined />,
      onClick: () => onShowEdit(true),
    },
    {
      label: "Delete",
      key: "2",
      icon: <DeleteOutlined />,
      onClick: () => showDeleteConfirm(),
    },
  ];

  // Table Function
  const onSelectedData = (val) => {
    setSelectedData(val);
  };
  const onSelectedDatas = (val) => {
    setSelectedDatas(val);
  };

  // Filter Variable & Function
  const onSearch = async (val) => {
    state.LOADING = true;

    await API.Get(`user?search=${val}`)
      .then((result) => {
        setDataUsers(result.data);
      })
      .catch((err) => {
        message.info("Failed Fetch Users Data!");
      });

    state.LOADING = false;
  };
  const exportExcel = () => {
    axios({
      url: `${baseUrl}/user/download`, // replace with the actual file URL
      method: "GET",
      responseType: "blob", // important
      headers: { Authorization: `Bearer ${getDataLogin().token}` },
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Master Users.xlsx"); // replace with the desired file name
        document.body.appendChild(link);
        link.click();
        message.success("File has been downloaded!");
      })
      .catch((error) => {
        message.info("Error downloading file!");
        console.error("Error downloading file:", error);
      });
  };
  const importExcel = (file) => {
    console.log("Import to Excel:", file);
  };

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Delete Confirm
  const showDeleteConfirm = () => {
    confirm({
      title: `Delete ${selectedData.name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${selectedData.name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`user/user_id/${selectedData.id}`)
          .then(() => {
            message.success("User has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete user");
            console.error(err);
          })
          .finally(() => {
            getUsers();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  useEffect(() => {
    getUsers();

    document.title = `Master Users | ${appName}`;
  }, []);

  return (
    <>
      <h2>Users</h2>
      <hr />

      {/* Filter Menu */}
      <FilterMenu
        selectedDatas={selectedDatas}
        onShowAdd={onShowAdd}
        onSearch={onSearch}
        onGetUsers={getUsers}
        exportExcel={exportExcel}
        importExcel={importExcel}
      />

      {/* Users Table */}
      <DynamicTable
        data={dataUsers}
        columns={columns}
        useOptions={true}
        options={options}
        selectedDatas={selectedDatas}
        onSelectedData={onSelectedData}
        onSelectedDatas={onSelectedDatas}
        onShowAdd={onShowAdd}
      />

      {/* Modal Add User */}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddUsers
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetUsers={getUsers}
        />
      </div>

      {/* Modal Edit User */}
      <EditUsers
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetUsers={getUsers}
        selectedData={selectedData}
      />
    </>
  );
}

export default Users;
